import { QUES_COMPONENT_TYPES } from '../componentTypes';

export default [
  {
    sequenceNumber: 1,
    subTitle: 'Level of Integration',
    content: 'How would you characterize the M&A transaction by deal type?',
    subSection: 'Integration Approach & Considerations',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'Transformational' },
      { text: 'Absorption / Consolidation' },
      { text: 'Tuck-In' },
      { text: 'Standalone' },
    ],
    compLocation: 'up',
    label: true,
  },
  {
    sequenceNumber: 2,
    subTitle: 'Acquired Entity Type',
    content:
      'Is the entity being purchased a Joint Venture (JV), Carve Out entity, or Wholly Acquired Entity?',
    subSection: 'Integration Approach & Considerations',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'Joint Venture (JV)' },
      { text: 'Carve-out entity' },
      { text: 'Wholly acquired entity' },
    ],
    compLocation: 'up',
  },
  {
    sequenceNumber: 3,
    subTitle: 'Diligence Conducted',
    content:
      'What types of operational diligence have been performed? Please select all that apply:',
    subContent: '[Select all that apply]',
    subSection: 'Integration Approach & Considerations',
    type: QUES_COMPONENT_TYPES.CHECKBOX,
    cols: 2,
    options: [
      { text: 'Information Technology' },
      { text: 'Cybersecurity / Privacy' },
      { text: 'HR' },
      { text: 'People & Org / Culture' },
      { text: 'Operations' },
      { text: 'Supply Chain' },
      { text: 'Sales and GTM' },
      { text: 'Products and Services' },
      { text: 'Billing & Coding' },
      { text: 'Revenue Cycle' },
    ],
    compLocation: 'up',
  },
  // {
  //   sequenceNumber: 3,
  //   subTitle: 'Requirement for TSAs',
  //   content: 'Are Transition Services Agreements (TSAs) anticipated?',
  //   subSection: 'Integration Complicating Factors',
  //   type: QUES_COMPONENT_TYPES.RADIO,
  //   options: [
  //     { text: 'TSA expected to be required' },
  //     { text: 'TSA not expected to be required' },
  //   ],
  //   compLocation: 'up',
  // },
  {
    sequenceNumber: 4,
    subTitle: 'Culture Comparison',
    content:
      'Are the purpose, mission and values between Buyer and Target aligned?',
    subSection: 'Workforce',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 5,
      extremeTexts: [
        'Very Similar',
        'Similar',
        'Somewhat Similar',
        'Dissimilar',
        'Very Dissimilar',
      ],
      compLocation: 'up',
    },
  },
  {
    sequenceNumber: 5,
    subTitle: 'Is the transaction viewed as hostile?',
    content: 'To what extent is the transaction viewed as hostile?',
    subSection: 'Integration Complicating Factors',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'Transaction viewed as Hostile' },
      { text: 'Transaction viewed as Non-Hostile' },
    ],
    compLocation: 'up',
  },
  {
    sequenceNumber: 6,
    subTitle: 'How much time is there to close?',
    content: 'How much time is there to close?',
    subSection: 'Integration Approach & Considerations',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: '< 3 months' },
      { text: '3 - 6 months' },
      { text: '> 6 months' },
    ],
  },
  {
    sequenceNumber: 7,
    subTitle: 'Likelihood of Delayed Deal',
    content:
      'What is the likelihood that the deal could be delayed due to regulatory challenges or extended review? Is there a risk of a mandated divestiture?',
    subSection: 'Integration Complicating Factors',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 5,
      extremeTexts: [
        'Very Unlikely',
        'Unlikely',
        'Somewhat Likely',
        'Likely',
        'Very Likely',
      ],
    },
    // compLocation: 'up',
    isStrategyCollapse: true,
  },
  {
    sequenceNumber: 8,
    subTitle: `Workforce Comparison`,
    content:
      'How does the number of employees at the Target compare to the number of employees at the Buyer?',
    subSection: 'Workforce',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'Buyer has significantly more employees than Target' },
      { text: 'Buyer & Target have relatively similar number of employees' },
      { text: 'Buyer has significantly less employees than Target' },
    ],
    compLocation: 'up',
    isStrategyCollapse: true,
  },
  {
    sequenceNumber: 9,
    subTitle: `Workforce Based Internationally`,
    content:
      "What percentage of the Target's workforce is based internationally?",
    subSection: 'Workforce',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: '0-25%' }, { text: '26-50%' }, { text: '51-100%' }],
    compLocation: 'up',
    isStrategyCollapse: true,
  },
  {
    sequenceNumber: 10,
    subTitle: `Guiding Principles`,
    content:
      'Have any early decisions / key guiding principles been established to set the planning and execution parameters for the transaction?',
    subSection: 'Integration Approach & Considerations',
    type: QUES_COMPONENT_TYPES.RADIOWITHINPUT,
    options: [
      { text: 'Yes' },
      { text: 'Some, but not complete' },
      { text: 'Not yet' },
    ],
    compLocation: 'up',
    attribute: 'Decisions / Guiding Principles', // for the input box title
  },
];
